<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryParams" :inline="true">
      <el-form-item prop="name">
          <el-input
          v-model="queryParams.name"
          placeholder="规则名称"
          clearable
          style="width: 240px"
          @keyup.enter.native="search"
          />
      </el-form-item>
      <el-form-item prop="productName">
        <el-input
          v-model="queryParams.productName"
          placeholder="套餐名称"
          clearable
          style="width: 240px"
          @keyup.enter.native="search"
          />
      </el-form-item>
      <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      <el-button type="primary" icon="el-icon-refresh" @click="reset">重置</el-button>
      <el-button type="primary" size="medium" icon="el-icon-plus" @click="adds" v-hasPermi="['rule:productSpeed:save']">新增</el-button>
    </el-form>
    <el-table :data="tableData" border style="margin-top: 10px">
      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="name" label="规则名称" align="center"></el-table-column>
      <el-table-column prop="highSpeed" label="限速值（M）" align="center" >
        <span  slot="header">
            限速值（M）
            <el-tooltip content="卡周期流量达到这个值开始限速处理" placement="top">
                <i class="el-icon-question"></i>
            </el-tooltip>
        </span>
        <template slot-scope="{row}">
          <p>{{row.highSpeed}}</p>
          <p><el-link type="primary" disabled>{{row.speedValue}}</el-link></p>
        </template>
      </el-table-column>
      <el-table-column prop="productNames" label="套餐列表" align="center" width="600px">
          <template slot-scope="{row}">
            <div class="product-list">
              <div class="product-item" v-for="(item,index) in row.productNames" :key="index" :title="item">
                    <span>{{item}}</span>
              </div>
              <div class="product-item">
                <el-button v-hasPermi="['rule:productSpeed:delete']" type="text" size="mini" class="el-icon-plus" @click="editProductSpeed(row)"></el-button>
                <el-button v-hasPermi="['rule:productSpeed:update']" v-if="row.productNames && row.productNames.length>0" type="text" size="mini" class="el-icon-delete"  @click="deleteProductSpeed(row)"></el-button>
              </div>
            </div>
          </template>
      </el-table-column>
      <el-table-column prop="freeProductName" label="赠送套餐" align="center">
        <span slot="header">
            赠送套餐
            <el-tooltip content="限速取消时，立即充值此套餐" placement="top">
                <i class="el-icon-question"></i>
            </el-tooltip>
        </span>
      </el-table-column>
      <el-table-column prop="createTime" label="创建日期" align="center"></el-table-column>
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
              <el-button  size="mini" type="danger" v-hasPermi="['rule:productSpeed:update']" @click="delRow(scope.row.id)" style="background:#24D2B5;border: 1px solid #24D2B5;">编辑</el-button>
              <el-button  size="mini" type="danger" v-hasPermi="['rule:productSpeed:delete']" @click="deleteRow(scope.row.id)" style="background:#F56C6C;border: 1px solid #F56C6C;">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="title"  width="750px" :visible.sync="dialog" @close="dialogClose" :lock-scroll="false" v-dialogDrag>
      <el-form :model="form" label-width="120px" ref="form" :rules="rules">
        <el-form-item label="规则名称:" prop="name">
          <el-input v-model="form.name" autocomplete="off" style="width: 85%" placeholder="请输入规则名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="套餐:" prop="productIds">
          <el-select v-model="form.productIds" multiple default-first-option filterable placeholder="请选择套餐" style="width: 85%">
            <el-option v-for="item in optPackage" :key="item.value" :label="item.label" :value="item.value" ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="限速值(M):" prop="highSpeed">
            <template slot="label">
              <span>限速值(M):</span>
              <el-tooltip class="item" effect="dark" placement="top">
                <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                <div slot="content">卡周期流量达到这个值开始限速处理</div>
              </el-tooltip>
            </template>
            <el-input v-model="form.highSpeed" autocomplete="off" style="width: 85%" placeholder="请输入限速值">
              <template slot="append">MB</template>
            </el-input>
        </el-form-item>
        <el-form-item label="赠送套餐:" prop="giveProductId">
            <template slot="label">
              <span>赠送套餐:</span>
              <el-tooltip class="item" effect="dark" placement="top">
                <i class="el-icon-question" style="font-size: 14px; vertical-align: middle;"></i>
                <div slot="content">符合本限速规则的套餐被取消限速后，自动赠送此套餐，不配置则不赠送</div>
              </el-tooltip>
            </template>
            <el-select v-model="form.giveProductId" filterable clearable placeholder="请选择取消限速后赠送的套餐" style="width: 85%" >
              <el-option v-for="item in optPackage" :key="item.value" :label="item.label" :value="item.value*1"></el-option>
            </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" @click="cancelDialog()">取消</el-button>
        <el-button type="success" @click="saveInfo()">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="设置限速套餐"  width="600px" :visible.sync="productDialog" @close="productDialogClose" :lock-scroll="false" v-dialogDrag>
      <el-form :model="productForm" label-width="100px" ref="productForm">
        <el-form-item label="套餐:" prop="productIds">
          <el-select v-model="productForm.productIds" multiple filterable placeholder="请选择套餐" style="width: 80%">
            <el-option v-for="item in productList" :key="item.id" :label="item.id + '-' + item.productName +'-' + item.validityTime + '天'" :value="item.id" ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="success" @click="updateSpeedRuleProduct">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import { productList } from "@/api/api.js"; // 不分页套餐列表
import { productSpeedList , selectSpeedRuleAndProducts , updateProductSpeedProductIds ,delProductFlowRule} from "@/api/api.js";
import { productFLowSpeedRulesAdd } from "@/api/api.js";
import { productFLowSpeedRulesDetail } from "@/api/api.js";
import { productFLowSpeedRulesUpdate } from "@/api/api.js";
import { productFLowSpeedRulesDelete } from "@/api/api.js";
export default {
  data() {
    const numberRule = (rule, value, callback) => {
      if (Number(value) >= this.form.highSpeed) {
        if (Number.isInteger(Number(value)) && Number(value) > 0) {
          callback()
        } else {
          callback(new Error('请输入大于零的正整数'))
        }
      } else {
        callback(new Error('低速限速值不能小于高速限速值'))
      }
    };
    return{
      queryParams:{
        name:undefined,
        productName:undefined
      },
      tableData:[],
      xsData:[],
      topArry:[],
      page: 1,
      pageSize: 20,
      total:0,
      searchTime:[],
      // 弹窗部分
      title:"",
      dialog:false,
      form:{},
      optPackage:[],
      rules:{
        name:[
          { required: true, message: "请输入规则名称", trigger: "blur" }
        ],
        highSpeed:[
          { pattern: /^-?[1-9]\d*$/, required: true, message: "请输入整数类型的高速限速值", trigger: "blur" }
        ],
        lowSpeed:[
          { pattern: /^-?[1-9]\d*$/,required: true, message: "请输入整数类型的低速限速值", trigger: "blur" }, { required: true,validator: numberRule, trigger: 'blur' }
        ],
      },
      productForm:{
        productIds:[],
        id:undefined
      },
      productDialog:false,
      productList:[],

    }
  },
    methods: {
    // 资费套餐下拉
    queryProductList() {
      productList().then(res => {
        if (res.data.code == 200) {
          this.dataList = res.data.data;
          this.dataList.forEach(item => {
            this.optPackage.push({
              value: item.id,
              label: `${item.id}-${item.productName}`
            });
          });
        }else if(res.data.code == 403){
          this.$message.error("权限不足，请联系管理员！");
        }else{
          this.$message.error(res.data.message);
        }
      });
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    reset() {
      this.resetForm("queryParams");
      this.initData();
    },
    // 获取列表的数据
    initData(){
      let params= {
          ...this.queryParams,
      }
      productSpeedList(params).then(res=>{
          this.tableData = res.data.data;
      });
    },
    // 新增
    adds(){
      this.title = "新增限速规则";
      this.dialog = true;
      this.form = {};
    },
    // 编辑
    delRow(id){
      this.title = "编辑限速规则";
      this.dialog = true;
      let params = {
        id:id
      }
      productFLowSpeedRulesDetail(params).then(res=>{
        if(res.data.code == 200){
          this.form = res.data.data;
        }else if(res.data.code == 403){
          this.$message.error("权限不足，请联系管理员！");
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    // 删除
    deleteRow(id){
      let params = {
        id:id
      }
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
			}).then(() => {
        productFLowSpeedRulesDelete(params).then(res=>{
          if (res.data.code == 200) {
            this.$notify({
              title: '成功',
              message: '删除限速规则成功',
              type: 'success'
            });
            this.initData();
          }else if(res.data.code == 403){
            this.$message.error("权限不足，请联系管理员！");
          }else{
            this.$message.error(res.data.message);
          }
        })
      })
    },
    // 弹窗的取消
    cancelDialog(){
      this.dialog = false;
    },
    // 弹窗的保存
    saveInfo(){
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.title == "新增限速规则") {
            let params ={
              ...this.form
            }
            productFLowSpeedRulesAdd(params).then(res=>{
              if(res.data.code == 200){
                this.$notify({
                  title: '成功',
                  message: '新增限速规则成功',
                  type: 'success'
                });
                this.dialog = false;
                this.initData();
              }else if(res.data.code == 403){
                this.$message.error("权限不足，请联系管理员！");
              }else {
                this.$message.error(res.data.message);
              }
            })
          }else{
            let params ={
              ...this.form
            }
            productFLowSpeedRulesUpdate(params).then(res=>{
              if(res.data.code == 200){
                this.$notify({
                  title: '成功',
                  message: '编辑限速规则成功',
                  type: 'success'
                });
                this.dialog = false;
                this.initData();
              }else if(res.data.code == 403){
                this.$message.error("权限不足，请联系管理员！");
              }else{
                this.$message.error(res.data.message);
              }
            })
          }
        }
      })
    },
    // 弹窗的x
    dialogClose(){
      this.$refs.form.clearValidate();
      this.dialog = false;
    },
    productDialogClose(){
      this.productDialog = false
      this.productForm.productIds = []
      this.productForm.id = undefined
    },
    deleteProductSpeed(row){
      this.$confirm('是否确认将【'+row.name+'】的套餐移除，移除后关联此套餐的限速取消？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            delProductFlowRule({id:row.id}).then(res=>{
                this.$message({type: 'success',message: '删除成功'});
                this.initData();
            })
        })
    },
    editProductSpeed(row){
      this.productDialog = true
      this.productForm.id = row.id;
      let id = row.id;
      selectSpeedRuleAndProducts({id}).then(res=>{
        this.productList = res.data.data.productList;
        this.productForm.productIds = res.data.data.productIds;
      })
    },
    updateSpeedRuleProduct(){
      updateProductSpeedProductIds(this.productForm).then(res=>{
        this.productDialog = false
        this.initData()
      })
    }
  },
  mounted() {
    this.queryProductList();
    this.initData();
  }
};
</script>
<style scoped lang="less">
.rotating {
  transform: rotate(90deg);
}
.el-button--small.icon-button-auto {
  padding: 12px 9px;
  position: relative;
  top: -1px;
}
.span-but{
  margin-left: -30px;
  button{
    padding: 10px 20px;
    margin-top: 3px;
    margin-left: 5px;
  }
}


.product-list{
  display: flex; /* 或者 inline-flex */
  flex-wrap: wrap; /* 允许元素在需要时换行 */
  width: 600px;
  color: #409eff;
  .product-item{
    border: 1px solid #dcdfe6;
    width: 280px; /* 设置子元素的宽度 */
    white-space: nowrap;
    overflow: hidden; /* 隐藏超出容器的文本 */
    text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
    height: 30px; /* 设置子元素的高度 */
    margin: 5px; /* 设置子元素的外边距 */
    background: #ecf5ff; /* 设置背景颜色 */
    line-height: 30px;
    align-content: flex-start;
    border-color: #b3d8ff;
    border-radius: 6px;
  }
}
</style>


